import { Alert, Badge } from "@/shared/components/MDX/MDXComponents";

# 🖇️ راهنمای تخصیص قطعات به ایستگاه‌های کاری (Allocations)

پلتفرم کارخانه‌سازی میمزاد (Mimzad Manufacturing Platform) — سند راهنمای کاربری

<Badge type="gold">سند استاندارد کاربری</Badge> <Badge>راهنمای جامع</Badge>

## 📋 معرفی سیستم تخصیص قطعات

در فرآیند تولید پیچیده، لازم است مشخص شود که هر قطعه از ساختار محصول (BOM) دقیقاً در کدام مرحله یا ایستگاه کاری (Routing Operation) به خط تولید وارد و مونتاژ می‌شود. به این فرآیند **Allocation** (تخصیص مواد به ایستگاه) می‌گویند.

### نحوه عملکرد این صفحه:

1. ابتدا **نسخه BOM** مورد نظر و **نسخه مسیر تولید (Routing Revision)** مرتبط را از فیلترهای بالای صفحه انتخاب کنید.
2. با بارگذاری اطلاعات، یک **نمودار تعاملی (Flowchart)** از ایستگاه‌های کاری در مرکز صفحه و لیستی از **قطعات تخصیص‌نیافته** در پنل کناری به شما نمایش داده می‌شود.
3. برای تخصیص هر قطعه:
   - روی نودِ (ایستگاه) مورد نظر در گراف کلیک کنید (یا از منوی کشویی فرم آن را انتخاب نمایید).
   - قطعه‌ی مورد نظر را از لیست کناری کلیک کنید (یا از منوی کشویی فرم برگزینید).
   - روی دکمه‌ی تخصیص کلیک کنید.
4. با این کار قطعه به ایستگاه مربوطه متصل شده و در پایین صفحه در جدول تخصیص‌های فعال قرار می‌گیرد.

<Alert type="tip">
  **قانون تخصیص یک‌به‌یک (Strict 1:1):** هر قطعه در BOM تنها می‌تواند به **یک** ایستگاه کاری متصل باشد. اگر قطعه‌ای را که قبلاً به یک ایستگاه تخصیص یافته است، مجدداً به ایستگاه جدیدی تخصیص دهید، سیستم به طور خودکار تخصیص قبلی را غیرفعال (Archived) کرده و آن قطعه را به ایستگاه جدید منتقل می‌کند.
</Alert>
